import { KClock } from "kinnect-general";
import {
	VAppBar,
	VImg,
	VSpacer
} from "vuetify/lib";

export default {
	name: "KKioskHeader",

	functional: true,

	render( h, context ) {
		const clockClass = context.parent.$root.$vuetify.breakpoint.mdAndUp
			? "text-h4"
			: "text-subtitle-1";

		return <VAppBar app height="95px">
			<RouterLink to={{ name: "front" }}>
				<VImg
					maxWidth={187}
					src={require( "@/assets/logos/logo-kiosk.png" )}
				></VImg>
			</RouterLink>

			<VSpacer></VSpacer>

			<KClock
				class={clockClass}
				format="EEEE, MMMM do, yyyy"
				updateInterval={60000}
			></KClock>

			<VSpacer></VSpacer>

			<KClock
				class={clockClass}
				format="h:mm:ss a"
			></KClock>
		</VAppBar>;
	}
};
